export const TAU = Math.PI * 2;

export function random(min: number, max: number) {
  return Math.random() * (max - min) + min;
}

export function pickRandom<T>(list: readonly T[]): T {
  return list[Math.floor(Math.random() * list.length)];
}
